<template>
  <section>
    <section>The <b class="mark">F</b>ront <b class="mark">E</b>nd</section>
    <section>
      <img src="@/assets/images/lion.jpg" alt="" width="400" />
      <p>WEB前端开发工程师</p>
    </section>
    <section>
      <img src="@/assets/images/dog.jpg" alt="" width="400" />
      <p>切图仔</p>
    </section>
  </section>
</template>
